const CLIENT_VIEW_BASE_ROUTE = '/client';
export default {
  oauth2LoginSuccess: '/oauth2-login-success',
  oauth2LogoutSuccess: '/',
  clientDashboard: {
    name: 'client-view',
    path: `${CLIENT_VIEW_BASE_ROUTE}/:clientId`,
    children: {
      dashboard: {
        name: 'client-dashboard',
        path: `${CLIENT_VIEW_BASE_ROUTE}/:clientId/dashboard`
      },
      plan: {
        name: 'client-plan',
        path: `${CLIENT_VIEW_BASE_ROUTE}/:clientId/plan`
      },
      manage: {
        name: 'client-manage',
        path: `${CLIENT_VIEW_BASE_ROUTE}/:clientId/manage`
      },
      reports: {
        name: 'client-reports',
        path: `${CLIENT_VIEW_BASE_ROUTE}/:clientId/reports`,
        children: {
          upcoming: {
            path: `${CLIENT_VIEW_BASE_ROUTE}/:clientId/reports/upcoming`,
            name: 'upcoming-reports'
          },
          completed: {
            path: `${CLIENT_VIEW_BASE_ROUTE}/:clientId/reports/completed`,
            name: 'completed-reports'
          }
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/router/constants.js